module.exports = __webpack_public_path__ + "static/media/whatsapp-image.f88b75ba.svg";